import { superToggle } from "./helpers/super-toggle";
import { bodyLockToggle } from "./helpers/body-lock-toggle";

window.addEventListener('load', event => {
    let buttons = document.getElementsByClassName('maintenance-contact-modal-toggle');
    let maintenanceContactOverlay = document.getElementById('maintenanceContactOverlay');

    if (maintenanceContactOverlay) {
        for (let button of buttons) {
            button.addEventListener('click', event => {
                superToggle(maintenanceContactOverlay, ['pointer-events-none', 'opacity-0']);
                bodyLockToggle();
            });
        }
    }
});